import { render, staticRenderFns } from "./ShareButtons.vue?vue&type=template&id=2ae360e2&scoped=true&"
import script from "./ShareButtons.vue?vue&type=script&lang=js&"
export * from "./ShareButtons.vue?vue&type=script&lang=js&"
import style0 from "./ShareButtons.vue?vue&type=style&index=0&id=2ae360e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae360e2",
  null
  
)

export default component.exports